import { Clock } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ItemLocation } from '../types/item-location'
import { ItemLocationMapDialog } from './ItemLocationMapDialog'
import { ItemLocationTimeline } from './ItemLocationTimeline'

export function ItemLocations({
  itemLocations,
  maxItems,
  isLoading = false,
}: {
  itemLocations: ItemLocation[]
  maxItems?: number
  isLoading?: boolean
}) {
  const { t } = useTranslation()

  const [itemLocationMapOpen, setItemLocationMapOpen] = useState(false)
  const [selectedLocation, setSelectedLocation] = useState<ItemLocation | null>(null)

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-8 text-xs text-muted-foreground">
        <Clock className="size-4 animate-spin" />
      </div>
    )
  }

  const display = maxItems ? itemLocations.slice(0, maxItems) : itemLocations

  if (display.length === 0) {
    return (
      <div className="flex items-center justify-center py-8 text-xs text-muted-foreground">
        {t('common.logTimeline.noHistory')}
      </div>
    )
  }

  return (
    <>
      <ItemLocationTimeline
        itemLocations={display}
        onViewMap={location => {
          setSelectedLocation(location)
          setItemLocationMapOpen(true)
        }}
      ></ItemLocationTimeline>

      <ItemLocationMapDialog
        open={itemLocationMapOpen}
        onOpenChange={open => {
          setItemLocationMapOpen(open)

          if (!open) {
            setSelectedLocation(null)
          }
        }}
        selectedLocation={selectedLocation ?? null}
        itemLocations={display}
      ></ItemLocationMapDialog>
    </>
  )
}
